import styles from "./CalendarPage.module.scss";
import LeagueHub from "../../components/LeagueHub/LeagueHub";

export default function CalendarPage() {
    return (
        <section className={styles.calendarPage}>
            <LeagueHub />
        </section>
    );
}
